import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import * as Color from "../Color";
import { MessageAppearance } from "./MessageAppearances";
import styled, { css } from "styled-components";

const containerStyles = css<{ appearance: MessageAppearance }>`
  border-radius: 0.25rem;
  background-color: ${(props) => Color.toString(props.appearance.backgroundColor)};
  border: solid 1px ${(props) => Color.toString(props.appearance.borderColor ?? props.appearance.backgroundColor)};
  color: ${(props) => (props.appearance.foregroundColor ? Color.toString(props.appearance.foregroundColor) : "inherit")};
  padding: 0.5rem 1rem;

  &>.content {
    flex: 1;
  }

  &>.icon {
    align-self: flex-start;
    padding-top: 1px;
  }

  &>.re-orderable-content {
    flex: 1;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;

    .icon {
      padding-top: 2px;
    }
    .text-wrapper {
      flex: 1;
      align-items: flex-start;
      justify-content: space-between;
      div {
        flex: 1;
        align-items: flex-start;
      }
    }
    .button {
      display: flex;
      align-items: flex-start;
      padding: 0;
    }
  }

`;

export const StyledShelf = styled(Shelf)<{ appearance: MessageAppearance }>`
  ${containerStyles}
`;

export const StyledStack = styled(Stack)<{ appearance: MessageAppearance }>`
 ${containerStyles}
`;
